import React, { Suspense } from "react";
import styled from "styled-components";

import cartDesktop from "../../../../../../assets/images/cartDesktop.png";
import { translate } from "../../../../../../services/translation.service";
import theme from "../../../../../../theme";
import { ICart } from "../../../../../../types/cart";
import { OrderRecapBody } from "../../../../components/OrderRecap";

interface IIcon {
  name: string;
  size: number;
}
const DesktopIcon = styled.i<IIcon>`
  display: flex;
  align-items: center;

  &:before {
    content: "";
    display: inline-block;
    width: ${({ size }: IIcon): number => size}px;
    height: ${({ size }: IIcon): number => size}px;
    background-image: url(${({ name }: IIcon): string | undefined => name});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transform: translateY(1%);
    margin-right: 5px;
  }
`;

const WrapperMiniCart = styled.div`
  flex-shrink: 0;
`;

const IconMiniCart = styled.div`
  cursor: pointer;
  display: flex;
  flex-basis: auto;
  align-items: center;
  padding: 13px 16px;
  color: ${theme.colors.white};

  .cart-label {
    color: ${theme.colors.grey};
  }

  &:hover span {
    color: ${theme.colors.white};
  }

  ${DesktopIcon} {
    margin: 0;
    text-align: left;

    :before {
      transform: translateY(10%);
    }
  }
`;

interface IMiniCart {
  hasProduct: boolean;
  isSearchOpen: boolean;
  productsCount: number | "";
  toggleRecap: () => void;
  cart: ICart | null;
  cartLoading: boolean;
  isCheckout: boolean;
  isRecapOpen: boolean;
  headerHeight: number;
  className?: string;
}

const MiniCart = ({
  productsCount,
  toggleRecap,
  cart,
  cartLoading,
  isRecapOpen,
  headerHeight,
  hasProduct,
  className,
}: IMiniCart): JSX.Element => {
  return (
    <WrapperMiniCart className="mini-cart">
      <IconMiniCart onClick={toggleRecap} className={className}>
        <DesktopIcon name={cartDesktop} size={29} />
        <div>
          <span className="cart-label">Panier</span>
          <div>
            {translate("cart.products", {
              count: productsCount || 0,
            })}
          </div>
        </div>
      </IconMiniCart>
      <Suspense fallback={<div />}>
        <OrderRecapBody
          cart={cart}
          cartLoading={cartLoading}
          isCheckout={false}
          headerHeight={headerHeight}
          isOpen={isRecapOpen}
          toggleOpen={toggleRecap}
          hasProduct={hasProduct}
        />
      </Suspense>
    </WrapperMiniCart>
  );
};

export default MiniCart;
